<template>
  <div class="headerFixed">
    <div class="info">
      <div class="flex">
        <p class="flex" v-if="contact.TEL"><img src="../assets/img/tel.png" alt="" width="20">{{ contact.TEL }}</p>
        <p class="flex email" v-if="contact.EMAIL"><img src="../assets/img/email.png" alt=""
                                                        width="20">{{ contact.EMAIL }}</p>
      </div>
      <div class="flex">
        <p class="flex"><img src="../assets/img/adress.png" alt="" width="20">
          {{ LocationCity }}
          <img src="../assets/img/drop.png" alt="">
        </p>
        <span class="language">EN</span>
      </div>
    </div>
    <div class="navbar flex">
      <div class="flex titPersonnel" style="cursor: pointer;"
           @click="navbarType='normal',$router.push('/index'),active=0">
        <img src="../assets/img/logo.png" alt="" width="23">
        <strong>{{ name + studio }}</strong>
      </div>
      <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" router text-color="#191E42" active-text-color="#567BFF">
        <template  v-for="(item,index) in doctorsNavbar">
          <el-submenu :key="index" :index="'a'+index"  v-if="item.children">
            <template slot="title">
              <span slot="title">{{ item.title }}</span>
            </template>
            <el-menu-item
                v-for="child in item.children"
                :index="child.path"
                :key="child.path">
              <span class="name">{{ child.title }}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item  :key="'b'+index" :index="item.path" v-else>
            <span slot="title">
              <el-badge v-if="item.title=='预约管理'" :value="message" class="item" :max="99"
                        :hidden="message==0">{{ item.title }}
              </el-badge>
               <template v-else>{{ item.title }}</template>
            </span>
          </el-menu-item>
        </template>
      </el-menu>
      <el-dropdown @command="handleCommand" style="width: 62px;">
        <el-badge :value="message+systemMessage" class="item" :max="99" :hidden="message+systemMessage===0">
          <el-avatar
              id="h_img"
              :src="headImgPath"
              size="medium"
              fit="scale-down"
              class="el-dropdown-link"></el-avatar>
        </el-badge>
        <el-dropdown-menu slot="dropdown" class="dropMenu">
          <el-dropdown-item command="homepage">个人主页</el-dropdown-item>
          <el-dropdown-item command="account">账号管理</el-dropdown-item>
          <el-dropdown-item command="message">系统通知
            <el-badge :value="systemMessage" class="mark" :hidden="systemMessage===0"></el-badge>
          </el-dropdown-item>
          <el-dropdown-item command="follower">我的粉丝</el-dropdown-item>
          <el-dropdown-item command="communicateDoc">私信消息
            <el-badge class="mark" :value="commUnreadMsgCount" :hidden="commUnreadMsgCount===0"/>
          </el-dropdown-item>
          <el-dropdown-item command="bindwx">绑定微信</el-dropdown-item>
          <el-dropdown-item command="resetPwd">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 绑定微信组件 -->
    <bind-wx ref="bindwx"></bind-wx>
  </div>
</template>

<script>
import SysCons from '@/api/common';
import {avatar, badge, dropdown, dropdownItem, dropdownMenu, tooltip} from 'element-ui';
import {mapGetters, mapMutations} from 'vuex';
import {getAxios} from "@/api/http";
import SysConstant from '@/api/system_constant';
import docMenu from '@/api/doctor_menu_permission';
import bindWx from '@/components/common/bind-wx';

export default {
  name: "headerCommon",
  data() {
    return {
      LocationCity: "深圳",
      userType: '',
      studio: '工作室',
      active: -1,
      doctorsNavbar: [{title: '主页', path: '/', sort: 1}],
      unLogin: true,
      headImgPath: localStorage.headImg || '',
      name: localStorage.name || '',
      countNotReadMessage: 0,
      contact: SysConstant.TOP_CONTACT,
    }
  },
  computed: {
    ...mapGetters(['message']),
    ...mapGetters(['systemMessage']),
    ...mapGetters(['commUnreadMsgCount']),
  },
  async mounted() {
    this.checkLoginStatus();
    let vm = this;
    getAxios(SysCons.api.appoint.message)
        .then((res) => {
          if (res.data.status == "success") {
            vm.setMessage(res.data.data)
          }
        });
    this.countNotRead();

    // 加载可用菜单
    let user = await SysCons.utils.getCurrent();
    if (user != null && user.type == 2) {
      this.username = user.account;
      localStorage.setItem('curAccount', user.account);
      localStorage.setItem('curUid', user.id);
      // 获取权限动态分配菜单
      let permissions = await this.$ajax.post(SysCons.api.permissions_me).then(res => {
        if (res.data.status === 'success') {
          return res.data.list;
        } else {
          return [];
        }
      });
      this.doctorsNavbar = docMenu.getMenuByPermissions(permissions);
      this.doctorsNavbar[1].path = '/workbench/' + localStorage.account;
      // 将permission存入store
      localStorage.setItem("permission", JSON.stringify(permissions));
    }
  },
  inject: ['reload'],
  methods: {
    ...mapMutations(['setMessage']),
    ...mapMutations(['setSystemMessage']),
    /*city() {    //定义获取城市方法
        const geolocation = new BMap.Geolocation();
        var _this = this
        geolocation.getCurrentPosition(function getinfo(position) {
            let city = position.address.city;             //获取城市信息
            _this.LocationCity = city
        }, function () {
            _this.LocationCity = "定位失败"
        }, {provider: 'baidu'});
    },*/
    down(index) {
      this.active = index
    },
    handleCommand(command) {
      if (command == "logout") {
        let token = localStorage.access_token || '';
        // 20210426 错误时直接clear localstorage
        this.$ajax.get(SysCons.api.logout + "?token=" + token).then((res) => {
          this.unLogin = true;
          localStorage.clear();
          this.$router.push('/login');
        }).catch(()=>{
          this.unLogin = true;
          localStorage.clear();
          this.$router.push('/login');
        });
      } else if (command === "homepage") {
        this.$router.push('/' + localStorage.account)
      } else if (command === "message") {
        this.$router.push('/doctor/message')
      } else if (command === 'resetPwd') {
        this.$router.push('/forget')
      } else if (command === 'account') {
        this.$router.push('/doctor/info');
      } else if (command === 'communicateDoc') {
        this.$router.push('/doctor/communicateDoc')
      } else if (command === 'bindwx') {
        this.$refs['bindwx'].show();
      } else if(command === 'follower'){
        this.$router.push('/doctor/follower');
      }
    },
    checkLoginStatus() {
      let vm = this;
      // localStorage.removeItem("curUid");
      vm.headImgPath = localStorage.headImg || '';
      vm.name = localStorage.name || '';

      // 判断token是否有效
      if (localStorage.access_token) {
        this.$ajax.post(SysCons.api.current).then(res => {
          if (res.data.status === 'success') {
            this.unLogin = false;
            if (localStorage.user_type && localStorage.user_type == 2 && localStorage.account) {
              this.doctorsNavbar[0].path = '/' + localStorage.account
            }
          }
        });
      }

    },
    countNotRead() {
      let that = this;
      this.$ajax.get(SysCons.api.message.system.countNotRead)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.setSystemMessage(res.data.data)
            }
            // that.countNotReadMessage = res.data.data
          })
    }
  },
  components: {
    [avatar.name]: avatar,
    [dropdown.name]: dropdown,
    [dropdownMenu.name]: dropdownMenu,
    [dropdownItem.name]: dropdownItem,
    [tooltip.name]: tooltip,
    [badge.name]: badge,
    bindWx
  }
}
</script>
<!--<style>
.el-avatar > img {
  height: 109.98%;
}
</style>-->
<style scoped lang="scss">
@import '../assets/css/head.scss';

</style>
